import React from 'react';
import './Doublesidedplastic.css';
import Threerunn from '../../../imgs/Threerunner1.webp';
import Threerun from '../../../imgs/Threerunner2.webp';
import Threeru from '../../../imgs/Threerunner3.webp';


const Doublesidedplastic = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <div className="Mostcountr">
                    <img src={Threerunn} alt="72 Cavity PET Preforms Machine" className="Doublesidedp" />
                    <img src={Threerun} alt="72 Cavity PET Preforms Machine" className="Doublesidedp" />
                </div>
                 <div className="Mostcount">
                    <img src={Threeru} alt="72 Cavity PET Preforms Machine" className="Rotaryi-image" />
                </div>
                <p className="Generallyin-date">Double-sided plastic pallets</p>
                <p className="Generallyin-tex"> can be used both front and back, making them suitable
                    for racking and stacking. It is often used in food and beverage,
                    flour deep processing, chemical plants, cold storage, and other industries.</p>
                <p className="Generallyin-tex">The light, medium, and heavy weights of plastic pallets are divided
                    by the weight of the pallet itself. If it is light, it is for 6-10 kg,
                    mainly in the shape of nine legs; The medium size is 10-20 kg, mainly in
                    the six-runner Pallet and Three Runner type, while the heavy
                    type is more than 20 kg, and the double-sided type is dominant.</p>
                <p className="Generallyin-tex">So see here do you know how to choose the style of the pallet?
                    I believe your answer is YES!</p>
                <p className="Generallyin-date">Disha large two-platen injection molding machines can meet
                    the plastic pallets
                    injection production requirements of different size standards!</p>
            </div>
        </div>
    );
};

export default Doublesidedplastic;
